// extracted by mini-css-extract-plugin
module.exports = {"normal_weight":"deliveryCounter_normal_weight__S7S4N"};